import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "container text-center",
  style: {"margin-top":"20px"}
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "container text-center",
  style: {"margin-top":"20px"}
}, [
  /*#__PURE__*/_createElementVNode("h1", null, "More colleagues need to finish their strength mapping to view this report.")
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 2,
  class: "text-big custom-theme"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "container maxWidth-sm" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px"} }, null, -1)
const _hoisted_10 = { class: "title-container" }
const _hoisted_11 = { class: "title-text" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", { class: "hr-magazine hr-magazine-thick hr-magazine-left hr-magazine-short" }, null, -1)
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("hr", { class: "hr-magazine hr-magazine-thick hr-magazine-left hr-magazine-short" }, null, -1)

import { computed, onBeforeMount, provide, ref } from "vue";
import cms from "../services/cms/cms";
import { CustomSoloReportApiModel } from "../api-models";
import { CmsDocumentTypes } from "../services/cms/cms-type-configuration";
import { CmsCustomStrengthMapping } from "../services/cms/cms-type-definitions";
import CmsBody from "../components/cms/cms-body.vue";
import ShareButton from "../components/share-button.vue";
import { csContext } from "../services/cs-context";

const label = "dynamic-render";

const sharingReportType = "CustomFrameworkSoloReport";


export default /*#__PURE__*/_defineComponent({
  __name: 'custom-solo-report',
  props: {
    model: {}
  },
  setup(__props: any) {

const props = __props;

const doc = ref<CmsCustomStrengthMapping | null>(null);

const isLoaded = ref(false);

const belowRequiredResponseCount = ref(false);

const error = ref("");

const report = computed(() => props.model);
provide("report", report);

const values = ref<string[]>([]);
provide("values", values);

const titleHtml = computed(() => cms.asHtml(doc.value?.data?.report_title));

const subtitleHtml = computed(() => report.value.reportOwnerName);

const canShare = computed(() => !!props.model && csContext?.user?.id === props.model.reportOwnerId);

const reportEntityId = computed(() => {
  return `${csContext.user.id}|${props.model.customStatistics?.id.toLowerCase()}`;
});

const hideViewpointsSection = (): CmsCustomStrengthMapping | null => {
  if (doc.value !== null && !props.model.customStatistics.viewpointsItems) {
    doc.value.data.body = doc.value.data.body.filter((slice) => slice.slice_label !== label);
  }
  return doc.value;
};

onBeforeMount(async () => {
  if (props.model == null) {
    error.value =
      "There was a problem getting your report. Please try refreshing the page, and if that doesn't work, you can contact us at support@gyreteams.com";
    return;
  }

  if (!props.model.customStatistics?.soloItems) {
    belowRequiredResponseCount.value = true;
    return;
  }

  doc.value = await cms.getById(
    CmsDocumentTypes.CmsCustomStrengthMapping,
    props.model.userValues.metadata.id,
  );

  const reportList = doc.value.data?.body.find((slice) => slice.slice_type === "cms-report-list");
  values.value = reportList?.items.map((value) => value.report_list_text[0].text) as string[];
  doc.value = hideViewpointsSection();
  isLoaded.value = true;
});

// @Component({
//   components: { CmsBody, ShareButton, CustomSoloBarGraph, CustomViewpointsBarGraph },
// })
// export default class CustomSoloReport extends Vue {
//   @Prop() model!: CustomSoloReportApiModel;

//   doc: CmsCustomStrengthMapping | null = null;

//   isLoaded = false;

//   belowRequiredResponseCount = false;

//   error = "";

//   private label = "dynamic-render";

//   @Provide("report") report = this.model;

//   @ProvideReactive("values") values: string[] = [];

//   get titleHtml(): string {
//     return cms.asHtml(this.doc?.data?.report_title);
//   }

//   get subtitleHtml(): string {
//     return this.report.reportOwnerName;
//   }

//   get canShare(): boolean {
//     return !!this.model && csContext?.user?.id === this.model.reportOwnerId;
//   }

//   get sharingReportType(): ReportSharingTypeApiModel {
//     return "CustomFrameworkSoloReport";
//   }

//   get reportEntityId(): string {
//     return `${csContext.user.id}|${this.model.customStatistics?.id.toLowerCase()}`;
//   }

//   hideViewpointsSection(): CmsCustomStrengthMapping | null {
//     if (this.doc !== null && !this.model.customStatistics.viewpointsItems) {
//       this.doc.data.body = this.doc.data.body.filter((slice) => slice.slice_label !== this.label);
//     }
//     return this.doc;
//   }

//   async beforeMount() {
//     if (this.model == null) {
//       this.error =
//         "There was a problem getting your report. Please try refreshing the page, and if that doesn't work, you can contact us at support@gyreteams.com";
//       return;
//     }

//     if (!this.model.customStatistics?.soloItems) {
//       this.belowRequiredResponseCount = true;
//       return;
//     }

//     this.doc = await cms.getById(
//       CmsDocumentTypes.CmsCustomStrengthMapping,
//       this.model.userValues.metadata.id,
//     );

//     const reportList = this.doc.data?.body.find((slice) => slice.slice_type === "cms-report-list");
//     this.values = reportList?.items.map((value) => value.report_list_text[0].text) as string[];
//     this.doc = this.hideViewpointsSection();
//     this.isLoaded = true;
//   }
// }

return (_ctx: any,_cache: any) => {
  return (error.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(error.value), 1)
      ]))
    : (belowRequiredResponseCount.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : (!error.value && !belowRequiredResponseCount.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (isLoaded.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", {
                          class: "report-title",
                          innerHTML: titleHtml.value,
                          "data-test": "title"
                        }, null, 8, _hoisted_12),
                        _hoisted_13,
                        _createElementVNode("p", {
                          class: "report-subtitle",
                          innerHTML: subtitleHtml.value,
                          "data-test": "subtitle"
                        }, null, 8, _hoisted_14),
                        _hoisted_15
                      ]),
                      (canShare.value)
                        ? (_openBlock(), _createBlock(ShareButton, {
                            key: 0,
                            reportEntityId: reportEntityId.value,
                            reportType: sharingReportType,
                            urlDescription: ""
                          }, null, 8, ["reportEntityId"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode(CmsBody, {
                    cmsPage: doc.value,
                    completedActivityIds: []
                  }, null, 8, ["cmsPage"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
}
}

})